class LtProductFamily extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const data = this.querySelector('.lt-family-variant-data');
    if (!data) { this.hidden = true; return; }
    let family;
    try { family = JSON.parse(data.textContent); } catch { return; }
    this.addEventListener('click', event => {
      const link = event.target.closest('a[data-family-handle]');
      if (!link || !this.contains(link)) return;
      const current = family.find(p => p.handle === this.dataset.handle);
      const target = family.find(p => p.handle === link.dataset.familyHandle);
      if (!current || !target) return;
      const details = this.closest('.product-details') || document;
      const id = details.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const variant = current.variants.find(v => String(v.id) === id);
      const url = new URL(link.getAttribute('href'), location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      // Preserve only exact matching option names and values, never a source variant ID.
      if (variant && current.control === target.control) {
        const match = target.variants.find(v => target.options.every((name, i) => {
          const sourceIndex = current.options.indexOf(name);
          return sourceIndex >= 0 && v.options[i] === variant.options[sourceIndex];
        }));
        if (match) url.searchParams.set('variant', String(match.id));
      }
      link.href = url.href;
    });
  }
}
if (!customElements.get('lt-product-family')) customElements.define('lt-product-family', LtProductFamily);
